/**
 * Wrap content tables so wide ones scroll horizontally instead of overflowing the page
 */
export default function postTables() {
    document.querySelectorAll('.gh-content table').forEach((table) => {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table-wrap';
        table.replaceWith(wrapper);
        wrapper.appendChild(table);
    });
}
